import { Sun, Moon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "./theme";

interface ThemeToggleProps {
  label?: string;
  lightLabel?: string;
  darkLabel?: string;
}

export function ThemeToggle({ label = "Thema wisselen", lightLabel, darkLabel }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const ariaLabel = isDark ? darkLabel || label : lightLabel || label;

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={ariaLabel}
      onClick={toggleTheme}
      className="text-foreground hover:bg-muted"
    >
      {isDark ? <Moon className="h-5 w-5" /> : <Sun className="h-5 w-5" />}
    </Button>
  );
}
